import React, {createContext} from "react";

import {IResolvedFeatureFlags} from "../types/IResolvedFeatureFlag";

export const FeatureFlagsContext = createContext<IResolvedFeatureFlags>({});

interface IProps {
    flags: IResolvedFeatureFlags;
    children: React.ReactNode;
}

export const FeatureFlagsProvider: React.FC<IProps> = ({flags, children}) => (
    <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>
);
